import { lazy } from 'react';

import type { RouterType } from 'commons/modules/routers/routes';
import { MENU_KEYS, SCREENS_KEYS } from 'constants/constants';

const Operation = lazy(() => import('views/Compliance/Operation'));
const Restricted = lazy(() => import('views/Compliance/Restricted'));
const Services = lazy(() => import('views/Compliance/Services'));
const Audits = lazy(() => import('views/Compliance/Audits'));
const SalesPractices = lazy(() => import('views/Compliance/SalesPractices'));
const RiskClientReports = lazy(
  () => import('views/Compliance/RiskClientReports'),
);
const UnusualOperations = lazy(
  () => import('views/Compliance/UnusualOperations'),
);
const RiskAssessmentEbr = lazy(
  () => import('views/Compliance/RiskAssessmentEbr'),
);
const AlertLog = lazy(() => import('views/Compliance/AlertLog'));
const OperationalReports = lazy(
  () => import('views/Compliance/OperationalReports'),
);
const Complaints = lazy(() => import('views/Compliance/Complaints'));
const OperatedAmounts = lazy(() => import('views/Compliance/OperatedAmounts'));
const OperationalAlerts = lazy(
  () => import('views/Compliance/OperationalAlerts'),
);

const routers: RouterType[] = [
  {
    path: '/cumplimiento/operaciones',
    exact: true,
    component: Operation,
    menuKey: MENU_KEYS.administrationManagement,
    screenKey: SCREENS_KEYS.complianceOperaciones,
  },
  {
    path: '/cumplimiento/restringidos',
    exact: true,
    component: Restricted,
    menuKey: MENU_KEYS.administrationManagement,
    screenKey: SCREENS_KEYS.complianceRestringidos,
  },
  {
    path: '/cumplimiento/servicios',
    exact: true,
    component: Services,
    menuKey: MENU_KEYS.administrationManagement,
    screenKey: SCREENS_KEYS.complianceServices,
  },
  {
    path: '/cumplimiento/auditorias',
    exact: true,
    component: Audits,
    menuKey: MENU_KEYS.administrationManagement,
    screenKey: SCREENS_KEYS.complianceAudits,
  },
  {
    path: '/cumplimiento/practicas-venta',
    exact: true,
    menuKey: MENU_KEYS.administrationManagement,
    screenKey: SCREENS_KEYS.complianceSales,
    component: SalesPractices,
  },
  {
    path: '/cumplimiento/riesgo',
    exact: true,
    menuKey: MENU_KEYS.administrationManagement,
    screenKey: SCREENS_KEYS.complianceRiskAssessment,
    component: RiskClientReports,
  },
  {
    path: '/cumplimiento/operaciones-inusuales',
    exact: true,
    menuKey: MENU_KEYS.administrationManagement,
    screenKey: SCREENS_KEYS.complianceUnusualOperations,
    component: UnusualOperations,
  },
  {
    path: '/cumplimiento/ebr',
    exact: true,
    menuKey: MENU_KEYS.administrationManagement,
    screenKey: SCREENS_KEYS.complianceRiskAssessmentEbr,
    component: RiskAssessmentEbr,
  },
  {
    path: '/cumplimiento/alertas',
    exact: true,
    menuKey: MENU_KEYS.administrationManagement,
    screenKey: SCREENS_KEYS.complianceAlertLog,
    component: AlertLog,
  },
  {
    path: '/cumplimiento/reportes-operatividad',
    exact: true,
    menuKey: MENU_KEYS.administrationManagement,
    screenKey: SCREENS_KEYS.complianceOperationalReports,
    component: OperationalReports,
  },
  {
    path: '/cumplimiento/denuncias',
    exact: true,
    menuKey: MENU_KEYS.administrationManagement,
    screenKey: SCREENS_KEYS.complianceComplaints,
    component: Complaints,
  },
  {
    path: '/cumplimiento/montos-operados',
    exact: true,
    component: OperatedAmounts,
    menuKey: MENU_KEYS.administrationManagement,
    screenKey: SCREENS_KEYS.complianceOperatedAmounts,
  },
  {
    path: '/cumplimiento/alertas-operativas',
    exact: true,
    component: OperationalAlerts,
    menuKey: MENU_KEYS.administrationManagement,
    screenKey: SCREENS_KEYS.complianceOperationalAlerts,
  },
];

export default routers;
